import React, { useState, useContext, useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import { Link } from "react-router-dom"
import {ModalContext, UserContext} from "../../../context/index"
import Footer from '../../Layout/Footer/Footer'
import Icons from '../../Components/Icons'
import css from "./Auth.module.scss"
import hCss from "../../Layout/Header/Header.module.scss"
import lCss from '../../Layout/Layout.module.scss'
import {TourContext} from "../../../context";
import { getCookie } from "../../../utils";
import {USER_AUTH} from "../../../constant";
import Banner from "../../Components/Banners";

const LIST  = [
	{title: 'Оперативная информация', icon:'listIcon1'},
	{title: 'Все значимые мероприятия России и мира', icon:'listIcon2'},
	{title: 'Самый полный источник информации', icon:'listIcon3'},
	{title: 'Удобно планировать на год', icon:'listIcon4'}
]

function Auth (){
	const [sticky, setSticky] = useState(false)
	const {openModal} = useContext(ModalContext)
	const {tour, closeTour, onStepIndex, openTour } = useContext(TourContext)
	const { user } = React.useContext(UserContext)
	const history = useHistory()

	const login =  () => {
		closeTour()
		onStepIndex(tour.stepIndex + 1)
		openModal('login')
	}

	const registration = () => {
		openModal('registration')
	}

	useEffect(() => {
		const onScroll = () => {
			const height = document.getElementById('header').getBoundingClientRect().height
			if (window.scrollY > height + 150 && !sticky) {
				setSticky(true)
			} else if (window.scrollY < height + 150) {
				setSticky(false)
			}
		};
		window.addEventListener('scroll', onScroll);

		return () => {
			window.removeEventListener('scroll', onScroll);
		}
	},[])

	useEffect(()=>{
		// if(!getCookie('initialTour') && getCookie('initialTour') !== '0'){
		// 	history.push({pathname:'/'})
		// 	openTour({stepIndex: 0, tour: true})
		// }
	},[])

	return(
		<>
			<header id="header" className={hCss.header + ' ' +(sticky ? hCss.sticky : '')}>
				<div className={lCss.layout}>
					<div className={hCss.topline}>
						<Link to="/" className={hCss.logo}>
							<Icons name="logo"/>
						</Link>
						<div className={hCss.controls}>
							<div className={hCss.icon} onClick={login} data-target="auth">
								<Icons name="login"/>
							</div>
						</div>
					</div>
					<div className={hCss.title}>
						Структурированная база анонсов международных, общероссийских и региональных мероприятий с глубиной планирования до года: встречи на высшем уровне, заседания парламента и правительства, выставки, фестивали, светские мероприятия, пресс-конференции.
					</div>
				</div>
			</header>
			<div className={css.content}>
				<div className={lCss.layout}>
					<div className={css.buttons + ' '+ css.mt60}>
						<button className={lCss.button} onClick={registration}>Подключить тестовый доступ</button>
					</div>
					<div className={css.tile}>
						{LIST.map((e,i)=>
							<div className={css.tileItem} key={i}>
								<i className={css.tileIcon}><Icons name={e.icon}/></i>
								<span className={css.tileTitle}>{e.title}</span>
							</div>
						)}
					</div>
					<div className={css.video}>
						<iframe src="https://nfw.ria.ru/nfp/SPlayer.html?id=4782123"  frameBorder="0"/>
						{/*<i className={css.play}>*/}
							{/*<Icons name="play"/>*/}
						{/*</i>*/}
					</div>
					<div className={css.buttons}>
						<button className={lCss.button} onClick={registration}>Подключить тестовый доступ</button>
					</div>
					<Banner
						code={`
							<div id="adfox_173988149684188497"></div>
							<script>
								window.yaContextCb.push(()=>{
									Ya.adfoxCode.create({
										ownerId: 249922,
										containerId: 'adfox_173988149684188497',
										params: {
											pp: 'fpve',
											ps: 'hdeu',
											p2: 'fluh',
											puid1: '',
											puid2: '',
											puid3: '',
											puid4: '',
											puid5: '',
											puid6: ''
										}
									})
								})
							</script>
						`}
					/>
				</div>
			</div>
			<Footer/>
		</>
	)
}

export default Auth